import { TimelineLite, Power2 } from 'gsap'
import bus from './bus'
import UI from './utils/UI'

UI({
  component: '.js-heroImage',
  image: '.js-heroImage-image',
  inset: '.js-heroImage-inset',
  shape: '.js-heroImage-shape'
}, ({ component, image, inset, shape }) => {
  if (!component.length) {
    return
  }
  const tl = new TimelineLite({ onComplete: _ => bus.emit('hero-image-ready'), paused: true })
  tl.from(image, 0.3, { opacity: 0, y: 20, ease: Power2.easeInOut })
  if (shape) {
    tl.to(shape, 0.1, { opacity: 1, ease: Power2.easeInOut }, '0.15')
  }
  if (inset) {
    tl.to(inset, 0.1, { opacity: 1, ease: Power2.easeInOut }, '0.35')
  }
  bus.on('shapes-bg-ready', _ => tl.paused(false))
})
